import React from "react";
import { endSession } from "@/lib/session";

export class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950 p-6" data-testid="error-boundary">
        <div className="max-w-md text-center space-y-4">
          <h1 className="text-2xl font-extrabold text-slate-900 dark:text-white">Não foi possível carregar esta tela</h1>
          <p className="text-sm text-slate-500">Ocorreu uma falha de carregamento ou de sessão. Você pode tentar novamente ou sair e entrar de novo — não é necessário limpar o cache do navegador.</p>
          <div className="flex gap-2 justify-center">
            <button onClick={() => window.location.reload()} className="px-4 py-2 rounded-full border border-slate-300 text-sm font-semibold" data-testid="error-retry-btn">Tentar novamente</button>
            <button onClick={() => endSession()} className="px-4 py-2 rounded-full bg-emerald-600 text-white text-sm font-semibold" data-testid="error-relogin-btn">Sair e entrar novamente</button>
          </div>
        </div>
      </div>
    );
  }
}
